import { Component } from '../Component'
import { inject } from '../../services/di'
import { element } from '../CustomElement'
import { i18n } from '../../i18n/I18n'
import { LocationService } from '../../services/LocationService'
import { Link } from '../flipp-link/Link'
import { CategoryService } from '../../services/CategoryService'
import { BlackFridayService } from '../../services/BlackFridayService'

@element('blackfriday-banner')
export class BlackFridayBanner extends Component<any, any> {
    @inject location: LocationService
    @inject categoryService: CategoryService
    @inject bf: BlackFridayService

    protected prepare(): any {
        return this.categoryService
            .clarifyBlackFridayCategory()
            .then((category) => {
                return category
            })
    }

    render(category: string) {
        const isFrench = this.location.locale === 'fr-ca'
        const textClassAppendix = isFrench ? ' french' : ''
        const bfClassAppendix = this.bf.isOnHost() ? ' bf' : ''
        return (
            <div class="blackfriday-banner">
                <div
                    class={`blackfriday-banner__title ${textClassAppendix} ${bfClassAppendix}`}
                >
                    <p>{i18n('blackfriday_banner_title')}</p>
                </div>
                <div class={`blackfriday-banner__more ${textClassAppendix}`}>
                    {!this.bf.isOnHost() ? this.renderButton(category) : null}
                </div>
            </div>
        )
    }

    renderButton(category: string) {
        const textClassAppendix =
            this.location.locale === 'fr-ca' ? ' french' : ''
        const textClass = 'flipp-button' + textClassAppendix
        return (
            <Link class={textClass} to={category}>
                {i18n('blackfriday_deals')}
            </Link>
        )
    }
}
